/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PrescriptionValueResponse } from '../models/PrescriptionValueResponse';
import { request as __request } from '../core/request';

export class SapPrintInfosService {

    /**
     * @returns PrescriptionValueResponse Default Response
     * @throws ApiError
     */
    public static async sapPrintInfos({
        requestBody,
    }: {
        requestBody?: {
            storeCode: string,
            salesOrganization: string,
            distributionChannel: string,
            upcs: Array<string>,
        },
    }): Promise<PrescriptionValueResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/sap/print_infos`,
            body: requestBody,
        });
        return result.body;
    }

}
